import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateProductMultiplierType($companyId: ID!, $attributes: ProductMultiplierTypeAttributes!) {
    createProductMultiplierType(companyId: $companyId, attributes: $attributes) {
      productMultiplierType {
        id
        ...CreatedProductMultiplierType
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedProductMultiplierType on ProductMultiplierType {
    id
    multiplierType {
      id
      name
      summary
      }
      product {
          ... on AssetType {
            id
            name
          }
        }
      }
`
